var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.63477,
    y: 6.68994,
    width: 33.3333,
    height: 33.3333,
    rx: 16.6667,
    transform: "rotate(-3.86184 3.63477 6.68994)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1292 3.57195C22.6891 3.39918 25.1539 3.72277 27.5041 4.55403C29.8144 5.37121 31.8764 6.56253 33.6721 8.13111C35.4679 9.69976 36.9264 11.5827 38.0467 13.7624C39.1863 15.9796 39.8373 18.3794 40.0101 20.9394C40.1828 23.4992 39.8602 25.964 39.029 28.3142C38.2118 30.6246 37.0196 32.6865 35.4509 34.4823C33.8822 36.2781 31.9993 37.7365 29.8197 38.8568C27.6025 39.9964 25.2035 40.6473 22.6436 40.8202C20.0836 40.993 17.6181 40.6704 15.2678 39.8391C12.9574 39.0219 10.8955 37.8297 9.09975 36.2611C7.30407 34.6925 5.84644 32.8093 4.72617 30.6298C3.58659 28.4126 2.93469 26.0137 2.76184 23.4538C2.58903 20.8938 2.91256 18.4282 3.74387 16.0779C4.56107 13.7676 5.75235 11.7056 7.32094 9.90992C8.88953 8.11423 10.7727 6.65663 12.9523 5.53634C15.1695 4.39671 17.5692 3.74476 20.1292 3.57195Z",
    fill: "#212129",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDark);
export default __webpack_public_path__ + "static/media/check-dark.a5ec21d5a9b28c22e72b0b8feafc3956.svg";
export { ForwardRef as ReactComponent };